import typeforce from '@exodus/typeforce';
import { getTrezorMeta } from './trezor.js';
import assert from 'minimalistic-assert';
import { types } from './types.js';
export const getSupportedPurposes = (opts) => {
    typeforce({
        asset: types.asset,
        walletAccount: types.walletAccount,
    }, opts, true);
    const { asset, walletAccount: { compatibilityMode, isMultisig }, } = opts;
    const baseAsset = asset.baseAsset;
    const apiExists = !!baseAsset.api?.getSupportedPurposes;
    assert(!isMultisig || apiExists, 'baseAsset must have api.getSupportedPurposes for a multisig WalletAccount');
    if (apiExists) {
        const supportedPurposes = baseAsset.api?.getSupportedPurposes({
            ...opts,
            compatibilityMode,
            isMultisig,
        });
        assert(supportedPurposes?.length, 'at least one purpose must be supported');
        return supportedPurposes;
    }
    if (compatibilityMode === 'trezor') {
        const trezorMeta = getTrezorMeta(baseAsset);
        return [
            baseAsset.useBip84 && trezorMeta.isBip84(asset.name) && 84,
            trezorMeta.isSegwit(asset.name) ? 49 : 44,
        ].filter(Boolean);
    }
    return [
        baseAsset.useBip49 === true && 49,
        baseAsset.useBip84 === true && 84,
        44,
        baseAsset.useBip86 === true && 86,
    ].filter(Boolean);
};
export const getDefaultPurpose = (opts) => {
    return getSupportedPurposes(opts)[0];
};
